import React, { Component } from 'react';
import Section from './Section';
import moment from 'moment';
import { RFQ_TYPE_NAMES, INSURANCE_BY, CARGIL, ADANI, ARDEX, VISHAKA, VISHAKA_SERVICE_MODES } from 'Constants/commonConstants';
import { RFQ_TABLE_DATE_FORMAT, LINE_ITEM_DETAIL_DATE_FORMAT, CARGO_DETAILS, HANDLING_INSTRUCTIONS, PACKING_TYPES, PRODUCT_TYPE, HIKAL } from '../../constants/commonConstants';
import classNames from 'classnames';
import { toPascalCase } from '../../utils/validate'
import { Link } from 'react-router-dom';
import { isCoromandel, isDesmet, isVishaka } from 'Utils/index';
import TermsAndConditionsPopup from './TermsAndConditionsSection';
import { DOWNLOAD_UPLOADED_FILE, ACCEPT_TERMS_AND_CONDITIONS } from 'Constants/actionConstants';



export default class RFQFieldsSection extends Component {
   constructor(props) {
      super(props);

      this.state = {
         isOpen: true,
         isAccepted: (localStorage.getItem('termsAndConditionsAccepted') && JSON.parse(localStorage.getItem('termsAndConditionsAccepted'))) ? true : false,
			isCourierAccepted: (localStorage.getItem('courierTermsAndConditionsAccepted') && JSON.parse(localStorage.getItem('courierTermsAndConditionsAccepted'))) ? true : false,
         isTermsAndConditionsOpen: false
      };

      this.toggle = this.toggle.bind(this);
   }

   toggle() {
      this.setState({ isOpen: !this.state.isOpen });
   }

   componentDidMount() {
      const { rfq, termsAccepted } = this.props;
      const isVishakaCompany = rfq && VISHAKA.includes(rfq.companyId);
      if (isVishakaCompany && termsAccepted) {
         this.setState({ isAccepted: true });
         this.props.isTermAccepted(1, true);
      }
   }

   componentDidUpdate(prevProps) {
      const { rfq, termsAccepted } = this.props;
      const isVishakaCompany = rfq && VISHAKA.includes(rfq.companyId);
      if (isVishakaCompany && termsAccepted && !prevProps.termsAccepted) {
         this.setState({ isAccepted: true });
         this.props.isTermAccepted(1, true);
      }
   }

   handleAcceptTaC = () => {
      const { rfq, dispatch } = this.props;
      const isVishakaCompany = VISHAKA.includes(rfq.companyId);
      this.setState({
         isAccepted: !this.state.isAccepted,
         isTermsAndConditionsOpen: false
      }, () => {
         this.props.isTermAccepted(1, this.state.isAccepted);
         if (isVishakaCompany && this.state.isAccepted) {
            dispatch({
               type: ACCEPT_TERMS_AND_CONDITIONS,
               data: { rfq_id: rfq.id }
            });
         }
      });
   }

	handleCourierAccept = () => {
		this.setState({
			isCourierAccepted: !this.state.isCourierAccepted
		}, () => {
				this.props.isTermAccepted(2,this.state.isCourierAccepted);
		});
	}

   handleOpenTermsAndConditions = () => {
      const {isAccepted, isTermsAndConditionsOpen} = this.state;
      if(!isTermsAndConditionsOpen && !isAccepted){
         this.setState({
            isTermsAndConditionsOpen: true
         })
      } else {
         this.handleAcceptTaC()
      }
   }

   cancelTermsAndConditionPopup = () => {
      this.setState({
         isTermsAndConditionsOpen: false
      })
   }

   renderProductType = (rfq, prodCat) =>{
      if (isCoromandel(!!rfq ? rfq.companyId : '') || isDesmet(!!rfq ? rfq.companyId : '') || isVishaka(!!rfq ? rfq.companyId : '')){
         return rfq.rfqDetails.product_category_name
      }
      return prodCat
   }

   downloadUploadedFile = (fileName) => {
      const { dispatch } = this.props;
      dispatch({
         type: DOWNLOAD_UPLOADED_FILE,
         param: {
            fileName,
         },
      });
   };


   render() {

      const { rfq, termsAndConditionList } = this.props;
      let cargoDetail = "";
      const isHIKAL = HIKAL.includes(rfq.companyId);
      const isAwl = ADANI.includes(rfq.companyId);
      const isArdex = ARDEX.includes(rfq.companyId);
      const isVishaka = VISHAKA.includes(rfq.companyId);
      if (rfq.cargoInfo.cargoDetails && rfq.cargoInfo.cargoDetails.length > 0) {
         const cargoVal = rfq.cargoInfo.cargoDetails[0];
         cargoDetail = CARGO_DETAILS.filter((cargo) => { return cargo.value === cargoVal });
         cargoDetail = (cargoDetail && cargoDetail.length > 0) ? cargoDetail[0].name : '';
      }

      let instructions = "";
      if (rfq.cargoInfo.handlingInstructions && rfq.cargoInfo.handlingInstructions.length > 0) {
         let instructionsSelected = [];
         rfq.cargoInfo.handlingInstructions.map((inst) => {
            const instruction = HANDLING_INSTRUCTIONS.filter((ins) => { return ins.value === inst });
            if (instruction && instruction.length > 0) {
               instructionsSelected.push(instruction[0]);
            }
         })
         let allInstructions = "";
         instructionsSelected.map((sel) => (
            allInstructions = (allInstructions.length > 0) ? allInstructions + ', ' + (sel.value == 2 ? `${sel.name}(${rfq.temp_min} - ${rfq.temp_max} ${rfq.temp_name})`: sel.name) : sel.name
         ));
         instructions = allInstructions;
      }

      let prodCat = '';
      if (rfq.cargoInfo && rfq.cargoInfo.productCategory) {
         if(Array.isArray(rfq.cargoInfo.productCategory)) {
            prodCat = ((rfq.cargoInfo.productCategory || []).map(el => el.name) || []).join(', ');
         } else {
            const ctg = PRODUCT_TYPE.filter((type) => { return type.value === rfq.cargoInfo.productCategory });
            prodCat = (ctg && ctg.length > 0) ? ctg[0].name : '';
         }
      }

      let packtype = '';
      if (!isVishaka && rfq.cargoInfo && rfq.cargoInfo.packingType) {
         if(Array.isArray(rfq.cargoInfo.packingType)) {
            packtype = ((rfq.cargoInfo.packingType || []).map(el => el.name) || []).join(', ');
         } else {
            const pack = PACKING_TYPES.filter((type) => { return type.value === rfq.cargoInfo.packingType });
            packtype = (pack && pack.length > 0) ? pack[0].name : '';
         }
      }
      if (isVishaka && rfq.packing_type_name) {
         packtype = rfq.packing_type_name || ""
      }

      let duration = "";
      if (rfq) {
         const momentDuration = moment.duration(moment(rfq.rfqDetails.contractTenureTo).diff(moment(rfq.rfqDetails.contractTenureFrom)));
         const years = momentDuration.years();
         const months = momentDuration.months();
         const days = momentDuration.days();
         // Difference might be in years!
         if (years > 0) {
            duration = duration + years + ' Year(s) ';
         }
         if (months > 0) {
            duration = duration + months + ' Month(s) ';
         }
         if (days > -1) {
            duration = duration + (days + 1) + ' Day(s) ';
         }
      }

      const insuranceBy = INSURANCE_BY.filter((insurance) => { return insurance.value === rfq.rfqDetails.insuranceBy });

      const value = rfq.includesOtherCharges === true ? "Includes" : "Excludes"

      const sections = [
         {
            title: "Company",
            fields: [
               {
                  label: "Company Name",
                  value: rfq.companyName
               },
               {
                  label: "Branch",
                  value: rfq.companyBranch
               },
               {
                  label: "Bid Start Date & Time",
                  value: moment(rfq.rfqDetails.biddingStart).format(LINE_ITEM_DETAIL_DATE_FORMAT)
               },
               {
                  label: "Bid Close Date & Time",
                  value: moment(rfq.rfqDetails.biddingEnd).format(LINE_ITEM_DETAIL_DATE_FORMAT)
               },
               {... rfq && rfq.type === 9 ? {
                  label: "Instructions",
                  value: instructions
               } : null }
            ]
         },
         {
            title: "Contract",
            fields: [
               {... isHIKAL ? {
                     label: "Mode",
                     value: `${RFQ_TYPE_NAMES[rfq.type]} ${(rfq.type === 5 && isHIKAL) ? (rfq.rfqDetails || {}).serviceCategoryTypeName : ''}`
                  } : {
                  label: "Contract Tenure",
                  value: <span className="fs-12 fRegular">
                     {
                        rfq && rfq.rfqDetails && moment(rfq.rfqDetails.contractTenureFrom).format(RFQ_TABLE_DATE_FORMAT)
                     }
                     <span className="fBold"> to </span>
                     {
                        rfq && rfq.rfqDetails && moment(rfq.rfqDetails.contractTenureTo).format(RFQ_TABLE_DATE_FORMAT)
                     }
                     <span className="fs-14 fBold op-full theme-color"> {duration} </span>
                  </span>
               }},
               {... isHIKAL ? {
                  label: "Contract Tenure",
                  value: <span className="fs-12 fRegular">
                     {
                        rfq && rfq.rfqDetails && moment(rfq.rfqDetails.contractTenureFrom).format(RFQ_TABLE_DATE_FORMAT)
                     }
                     <span className="fBold"> to </span>
                     {
                        rfq && rfq.rfqDetails && moment(rfq.rfqDetails.contractTenureTo).format(RFQ_TABLE_DATE_FORMAT)
                     }
                     <span className="fs-14 fBold op-full theme-color"> {duration} </span>
                  </span> } : {
                  label: "Mode",
                  value: rfq.type == 8 ? rfq.rfqDetails?.serviceModeName : `${RFQ_TYPE_NAMES[rfq.type]} ${(rfq.type === 5 && isHIKAL) ? (rfq.rfqDetails || {}).serviceCategoryTypeName : ''}`
               }},
               {
                  label: "Bound type",
                  value: rfq.rfqDetails?.boundType === 1 ? <span>In-Bound</span> : <span>Out-Bound</span>,
                  classname: 'wt-200',
               },
               {
                  ...(isVishaka ? {
                     label: "Service Mode",
                     value: VISHAKA_SERVICE_MODES
                        .filter(mode => (rfq.rfqDetails?.serviceModes || []).includes(mode.value))
                        .map(mode => mode.name)
                        .join(', ')
                  } : {})
               },
               {
                  ...(rfq.type === 12 && isAwl) ?  {
                     label: "Movement Type",
                     value: (rfq.rfqDetails || {}).serviceTypeName || ''
                  } : null
               },
                {
                  ...(rfq.type === 12 && isAwl) ?  {
                     label: "Shipping Type",
                     value: rfq.shippingTypeName || ''
                  } : null
               },
               {
                  label: "Notes",
                  value: rfq.rfqDetails.contractNote ? rfq.rfqDetails.contractNote : '',
                  classname: 'wt-200',
               },
               {...rfq.type === 8 ? null : {
                  label: "Insurance By",
                  value: insuranceBy && insuranceBy.length > 0 ? insuranceBy[0].name : '',
               }},
               {...(rfq.type === 15 && isAwl) ?{
                  label: "Inco Terms",
                  value: rfq.eximIncoTerms ? rfq.eximIncoTerms : '',
               }: null},
            ]
         }, {
            title: "Payment",
            fields: [
               {...CARGIL.includes(rfq.companyId) ? null :
                  { 
                     label: "Payment By",
						   value: toPascalCase(rfq.paymentBy === 'Both' ? 'To Be Billed / To Pay' : rfq.paymentBy)
                  }
               },
               {...![10, 8].includes(rfq.type) ? {
                  label: `${(CARGIL.includes(rfq.companyId)) ? 'Pricing' : 'Payment'} Basis`,
                  value: rfq.paymentBasis
               } : null},
               {...(![1, 8].includes(rfq.type)) ? {
                  label: "Other Cost",
                  value: value
               } : null},
               {... isHIKAL ? {
                  label: "IncoTerms",
                  value: ((rfq.biddingDetails || {}).incoterms || {}).name,
               }: null},
            ]
         }, 
         {
            title: "Cargo",
            fields: [
               {... isHIKAL ? {
                  label: "Cargo Type",
                  value: rfq.cargoInfo.cargoTypeName,
               } : null},
               {
                  label: "Cargo Details",
                  value: cargoDetail
               },
               {
                  label: "Product Type",
                  value: this.renderProductType(rfq, prodCat)
               },
               (isDesmet(!!rfq?rfq.companyId:'')
                  ? {}
                  : {
                     label: "Packaging Type",
                     value: packtype
                  })
               ,
               {
                  label: "Instructions",
                  value: instructions
               },
               (isDesmet(!!rfq?rfq.companyId:'')
                  ? {}
                  : {
                     label: "Cargo Description",
                     value: rfq.cargoInfo.cargoDescription ? rfq.cargoInfo.cargoDescription : ""
                  })
               ,
               {
                  label: "Fuel Type",
                  value: <span className="fs-14 fBold op-full success-color"> 
                         {rfq.cargoInfo.fuelName ? rfq.cargoInfo.fuelName : "NA"}
                       </span>
               }
            ]
         }
      ];
      if(rfq.type === 8) {
         const findIndex = sections.findIndex(el => el.title == 'Cargo');
         sections.splice(findIndex, 1);
      }
      const sectioHeaders = sections.map(el => el.title);
      let secfields = [];
      (sections || []).forEach(el => {
         const findIndex = (el.fields || []).findIndex(el => !el.label);
         if(findIndex > -1) {
            el.fields.splice(findIndex, 1);
         }
         if(el.fields && (el.fields.length > (secfields.length))) {
            secfields = el.fields;
         }
      });
      return (
         <div className="box-shadow col-1 pl-20 pt-30 pr-40 pb-30 border-light br-5">
            <div className="flex flex-between curP" onClick={() => this.toggle()}>
               <span className="section-header-color fBold op-79 fs-18 ml-20">
                  Important Info
                    </span>
               <span className={classNames("triangle", {
                  "rotate-0": this.state.isOpen,
                  "rotate-180": !this.state.isOpen,
               })}>
               </span>
            </div>
            <div className={classNames("flex flex-between max-height-transition overflowYHidden ", {
               "max-ht-0": !this.state.isOpen,
               "max-ht-100vh": this.state.isOpen
            })}>
               <>
                  {rfq.type == 9 ?
                     <>{
                        sections.map((rfqSection, index) => {
                           return rfqSection && (rfq.type === 9 ? rfqSection.title === "Company" : true ) && <Section rfqSection={rfqSection} key={index} rfqType={rfq.type}/>
                        })
                     } </> :
                     <table className='wt-100p' cellspacing="15">
                        <thead>
                           {(sectioHeaders || []).filter(el => rfq.type === 8 ? el !== 'Cargo' : el).map(el => 
                              <th className='tStart'> 
                                 <span className="section-sub-header-color fBold fs-16">
                                    {el}
                                 </span>
                              </th>)}
                        </thead>
                        <tbody>
                        {(secfields || []).map((secEl, secIndex) => {
                           return(<tr>{
                           (sectioHeaders || []).map((el, index) => {
                              let field = sections[index].fields[secIndex] || {};
                                    return(<td className={classNames('', {
                                       'border-bottom-light': field.label
                                    })}>
                                       <div className={classNames("pb-20 pt-10", {
                                             'flex': rfq.type != 9
                                          })} key={index}>
                                          <div className="wt-150">
                                             <span className="section-sub-header-colo fs-14">
                                                {field.label || ''}
                                             </span>
                                          </div>
                                          <div className={(field && field.classname) ? field.classname : ""}>
                                             <span className="section-sub-header-color fBold fs-14 op-7">
                                                { field.value  || ''}
                                             </span>
                                          </div>
                                       </div>
                                    </td>)
                           })}
                           </tr>)
                        })}
                     </tbody>
                     </table>
                  }
               </>
            </div>
            {isVishaka && rfq.documents && rfq.documents.length > 0 &&
               <div className="pt-20 pr-40 pb-10">
                  <span className="section-sub-header-color fBold fs-16">Uploaded Documents</span>
                  <div className="flex flex-column mt-10">
                     {rfq.documents.map((doc, idx) => (
                        <div key={idx} className="flex mr-20 mb-10" style={{ alignItems: 'center' }}>
                           <span
                              className="curP theme-color fs-14"
                              onClick={() => this.downloadUploadedFile(doc.name)}
                           >
                              {doc.name}
                           </span>
                        </div>
                     ))}
                  </div>
               </div>
            }
            {isArdex ?
            <div className="flex pt-30 pr-40 pb-30">
               <input type="checkbox" className="mr-20 curP" checked={this.state.isAccepted} onChange={this.handleOpenTermsAndConditions} />
               <label> I Accept All {' '} <a className="curP theme-color" href={(rfq.documents && rfq.documents[0]) ? rfq.documents[0].url : ''}> Terms And Conditions </a>  </label>
            </div> :
            // <div className="flex pt-30 pr-40 pb-30">
            //    <input type="checkbox" className="mr-20 curP" checked={this.state.isAccepted} onChange={this.handleAcceptTaC} />
            //    <label> I Accept All {' '} <a className="curP theme-color" href={(rfq.documents && rfq.documents[0]) ? rfq.documents[0].url : ''}> Terms And Conditions </a>  </label>
            // </div>
            <div className="flex pt-30 pr-40 pb-30">
  <input
    type="checkbox"
    className="mr-20 curP"
    checked={this.state.isAccepted}
    onChange={this.handleAcceptTaC}
  />

  <label>
   I Accept All{' '}
    {isVishaka ? (
      <span>Terms And Conditions</span>
    ) : (
      <a
        className="curP theme-color"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          const fileName =
            rfq.documents && rfq.documents[0]
              ? rfq.documents[0].name
              : null;

          if (fileName) {
            this.downloadUploadedFile(fileName);
          }
        }}
      >
        Terms And Conditions
      </a>
    )}
  </label>
</div>

            }

				{(this.props.rfq.type === 4 || this.props.rfq.serviceType === 3) && 
					<div className="flex pr-40 pb-30">
					<input type="checkbox" className="mr-20 curP" checked={this.state.isCourierAccepted} onChange={this.handleCourierAccept} />
					<label> I have Updated<Link to="/transporters/88" className="curP theme-color"> Service Availability</Link></label>
					
					</div>
				}

            {this.state.isTermsAndConditionsOpen && 
            <TermsAndConditionsPopup termsAndConditionList={termsAndConditionList} onCancel={this.cancelTermsAndConditionPopup} onAgree={this.handleAcceptTaC}/> }
         </div>
      )
   }
}
